export interface WicketAdminUserChangelogAgreement {
  id: number;
  code: string;
  label_pl: string;
  agreement_full_text_pl: string;
  is_active: boolean;
  is_required: boolean;
  is_valid_from: string;
  is_valid_to: string;
  created_at: string;
  extra_data: Record<string, never>;
}

export interface WicketAdminUserAgreement {
  agreement_id: number;
  is_given: boolean;
  created_at: string;
  updated_at: string;
  updater_type: string;
  updater_id: string | null;
}
